export const legal = {
  // Legal Pages
  legalNotice: 'الإشعار القانوني',
  privacyPolicy: 'سياسة الخصوصية',
  cookiePolicy: 'سياسة ملفات تعريف الارتباط',
  termsOfUse: 'شروط الاستخدام',
  dataProtection: 'حماية البيانات',
  
  // Footer Legal Links
  legalMentions: 'الإشعار القانوني',
  footerLegalTitle: 'معلومات قانونية',
  
  // Common Legal Terms
  lastUpdated: 'آخر تحديث',
  effectiveDate: 'تاريخ السريان',
  company: 'الشركة',
  address: 'العنوان',
  vat: 'رقم الضريبة',
  contact: 'اتصل بنا',
  home: 'الرئيسية',
  
  // NEW: Legal Pages Content
  // Mentions Légales
  legalNoticeTitle: 'الإشعار القانوني',
  legalNoticeDescription: 'معلومات قانونية وفقاً للتشريعات البلجيكية والأوروبية',
  sitePublisher: 'ناشر الموقع',
  legalForm: 'الشكل القانوني',
  individualCompany: 'مؤسسة فردية',
  headquarters: 'المقر الرئيسي',
  phone: 'الهاتف',
  email: 'البريد الإلكتروني',
  publicationManager: 'مدير النشر',
  siteHosting: 'استضافة الموقع',
  host: 'المضيف',
  website: 'الموقع الإلكتروني',
  hostingNote: 'يتم استضافة الموقع على بنية تحتية سحابية آمنة متوافقة مع معايير حماية البيانات الأوروبية (GDPR).',
  intellectualProperty: 'الملكية الفكرية',
  intellectualPropertyText1: 'جميع محتويات هذا الموقع (النصوص، الصور، الشعارات، مقاطع الفيديو، الهيكل، التصميم) هي ملكية حصرية لـ Ktran، ما لم يُذكر خلاف ذلك.',
  intellectualPropertyText2: 'يُحظر بشكل صارم أي استنساخ أو توزيع أو تعديل أو تكييف أو إعادة نقل أو نشر لهذه العناصر المختلفة دون الموافقة الكتابية المسبقة من Ktran.',
  intellectualPropertyText3: 'العلامات التجارية والشعارات والعلامات المميزة المعروضة على هذا الموقع هي ملك لـ Ktran. يُحظر أي استنساخ كلي أو جزئي لهذه العلامات أو الشعارات دون إذن مسبق وكتابي من Ktran.',
  exception: 'استثناء',
  exceptionText: 'يُسمح للمستخدمين بالاطلاع على صفحات الموقع وطباعتها للاستخدام الشخصي الصارم وغير التجاري.',
  limitationOfLiability: 'حدود المسؤولية',
  liabilityText1: 'تبذل Ktran قصارى جهدها لضمان دقة وتحديث المعلومات المنشورة على هذا الموقع. ومع ذلك، لا يمكن لـ Ktran ضمان دقة أو صحة أو اكتمال المعلومات المتاحة على هذا الموقع.',
  liabilityText2: 'وبالتالي، تخلي Ktran مسؤوليتها عن:',
  liabilityList1: 'أي عدم دقة أو عدم صحة أو إغفال يتعلق بالمعلومات المتاحة على الموقع',
  liabilityList2: 'أي ضرر ناتج عن تدخل احتيالي من طرف ثالث أدى إلى تعديل المعلومات',
  liabilityList3: 'أي ضرر مباشر أو غير مباشر يلحق بالمستخدم، مهما كانت طبيعته، ناتج عن المحتوى أو الوصول أو استخدام الموقع',
  liabilityList4: 'استخدام الموقع من قبل المستخدم والعواقب التي قد تنجم عن ذلك',
  liabilityNote: 'تحتفظ Ktran بالحق في تعديل أو تصحيح محتوى هذا الموقع في أي وقت ودون إشعار مسبق.',
  hyperlinks: 'الروابط التشعبية',
  hyperlinksText1: 'قد يحتوي الموقع على روابط تشعبية لمواقع إنترنت أخرى. لا تمارس Ktran أي سيطرة على هذه المواقع وتخلي مسؤوليتها عن محتواها.',
  hyperlinksText2: 'يتطلب إنشاء روابط تشعبية إلى موقع ktran.be الحصول على إذن مسبق وكتابي من Ktran. يمكن إلغاء هذا الإذن في أي وقت.',
  applicableLaw: 'القانون المطبق والاختصاص القضائي',
  applicableLawText1: 'يخضع هذا الإشعار القانوني للقانون البلجيكي والأوروبي.',
  applicableLawText2: 'في حالة نشوء نزاع وفي حالة عدم التوصل إلى اتفاق ودي، سيتم عرض النزاع على المحاكم المختصة في بروكسل، بلجيكا.',
  gdprCompliance: 'الامتثال للائحة العامة لحماية البيانات',
  gdprComplianceText: 'هذا الموقع متوافق مع اللائحة العامة لحماية البيانات (GDPR) للاتحاد الأوروبي (EU 2016/679).',
  contactUs: 'اتصل بنا',
  contactUsText: 'لأي أسئلة تتعلق بالإشعار القانوني أو استخدام الموقع:',
  otherLegalInfo: 'معلومات قانونية أخرى',

  // Privacy Policy
  privacyPolicyTitle: 'سياسة الخصوصية',
  privacyPolicyDescription: 'حماية بياناتك الشخصية وفقاً للائحة العامة لحماية البيانات',
  privacyCommitment: 'التزام الخصوصية',
  privacyCommitmentText: 'تلتزم Ktran (رقم الضريبة: BE0729535515) بحماية خصوصية مستخدميها وعملائها. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وتخزين وحماية بياناتك الشخصية وفقاً للائحة العامة لحماية البيانات (GDPR - EU 2016/679) والتشريعات البلجيكية.',
  dataController: 'المسؤول عن معالجة البيانات',
  enterprise: 'المؤسسة',
  personalDataCollected: 'البيانات الشخصية المجمعة',
  identificationData: '1. بيانات التعريف',
  nameAndSurname: 'الاسم واللقب',
  emailAddress: 'عنوان البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  postalAddress: 'العنوان البريدي (الرمز البريدي والمدينة)',
  projectData: '2. البيانات المتعلقة بالمشاريع',
  desiredWorkType: 'نوع الأعمال المطلوبة',
  housingType: 'نوع السكن',
  projectDescription: 'وصف المشروع',
  projectPhotos: 'صور المشروع (إذا تم توفيرها)',
  estimatedBudget: 'الميزانية المقدرة',
  navigationData: '3. بيانات التصفح',
  ipAddress: 'عنوان IP',
  browserType: 'نوع المتصفح',
  pagesVisited: 'الصفحات التي تمت زيارتها',
  visitDateTime: 'تاريخ ووقت الزيارة',
  cookies: 'ملفات تعريف الارتباط (انظر سياسة ملفات تعريف الارتباط)',
  processingPurposes: 'أغراض المعالجة',
  processingPurposesText: 'يتم جمع ومعالجة بياناتك الشخصية للأغراض التالية:',
  quoteManagement: '📋 إدارة طلبات عروض الأسعار',
  quoteManagementDesc: 'معالجة والرد على طلبات عروض الأسعار الخاصة بك لأعمال التجديد',
  clientCommunication: '📞 التواصل مع العملاء',
  clientCommunicationDesc: 'الاتصال بك لمناقشة مشروعك وضمان المتابعة',
  serviceImprovement: '📊 تحسين الخدمات',
  serviceImprovementDesc: 'تحليل استخدام الموقع لتحسين خدماتنا',
  legalObligations: '⚖️ الالتزامات القانونية',
  legalObligationsDesc: 'احترام التزاماتنا القانونية والمحاسبية',
  legalBasis: 'الأساس القانوني للمعالجة',
  legalBasisText: 'تستند معالجة بياناتك الشخصية إلى الأسس القانونية التالية:',
  consent: 'الموافقة',
  consentText: 'توافق على معالجة بياناتك من خلال تقديم نموذج طلب عرض الأسعار',
  contractExecution: 'تنفيذ العقد',
  contractExecutionText: 'المعالجة ضرورية لتنفيذ عقد تقديم الخدمات',
  legitimateInterest: 'المصلحة المشروعة',
  legitimateInterestText: 'تحسين خدماتنا والتواصل التجاري',
  legalObligation: 'الالتزام القانوني',
  legalObligationText: 'الاحتفاظ بالبيانات لاحترام الالتزامات المحاسبية والضريبية البلجيكية',
  retentionPeriod: 'مدة الاحتفاظ بالبيانات',
  retentionPeriodText: 'يتم الاحتفاظ ببياناتك الشخصية للمدد التالية:',
  dataType: 'نوع البيانات',
  retentionDuration: 'مدة الاحتفاظ',
  quoteRequests: 'طلبات عروض الأسعار (العملاء المحتملون)',
  threeYears: '3 سنوات بعد آخر اتصال',
  clientData: 'بيانات العملاء (عقد موقع)',
  tenYears: '10 سنوات (الالتزامات المحاسبية البلجيكية)',
  navigationDataCookies: 'بيانات التصفح (ملفات تعريف الارتباط)',
  thirteenMonthsMax: '13 شهراً كحد أقصى',
  projectPhotosData: 'صور المشاريع',
  projectDurationPlusThree: 'مدة المشروع + 3 سنوات',
  retentionNote: 'عند انتهاء هذه المدد، يتم حذف بياناتك بشكل آمن أو إخفاء هويتها.',
  yourRights: 'حقوقك على بياناتك',
  yourRightsText: 'وفقاً للائحة العامة لحماية البيانات، لديك الحقوق التالية:',
  rightOfAccess: '✅ حق الوصول',
  rightOfAccessDesc: 'الحصول على نسخة من بياناتك الشخصية',
  rightOfRectification: '✏️ حق التصحيح',
  rightOfRectificationDesc: 'تصحيح بياناتك غير الدقيقة أو غير الكاملة',
  rightToErasure: '🗑️ حق المحو',
  rightToErasureDesc: 'طلب حذف بياناتك',
  rightToRestriction: '⏸️ حق التقييد',
  rightToRestrictionDesc: 'تقييد معالجة بياناتك',
  rightToPortability: '📦 حق النقل',
  rightToPortabilityDesc: 'تلقي بياناتك بتنسيق منظم',
  rightToObject: '🚫 حق الاعتراض',
  rightToObjectDesc: 'الاعتراض على معالجة بياناتك',
  howToExerciseRights: 'كيفية ممارسة حقوقك؟',
  howToExerciseRightsText: 'لممارسة أي من هذه الحقوق، اتصل بنا:',
  mail: 'البريد',
  responseTime: 'سنرد على طلبك في غضون شهر واحد كحد أقصى.',
  dataSecurity: 'أمن البيانات',
  dataSecurityText: 'تطبق Ktran جميع التدابير التقنية والتنظيمية المناسبة لحماية بياناتك الشخصية من:',
  accidentalDestruction: 'التدمير العرضي أو غير القانوني',
  accidentalLoss: 'الفقدان العرضي',
  unauthorizedAccess: 'التعديل أو النشر أو الوصول غير المصرح به',
  illegalProcessing: 'أي شكل آخر من أشكال المعالجة غير القانونية',
  securityMeasures: '🔒 تدابير الأمان المطبقة:',
  sslEncryption: '✓ تشفير SSL/TLS لجميع الاتصالات',
  gdprHosting: '✓ استضافة آمنة متوافقة مع اللائحة العامة لحماية البيانات',
  restrictedAccess: '✓ وصول محدود إلى البيانات (المصادقة)',
  regularBackups: '✓ نسخ احتياطية منتظمة وآمنة',
  incidentMonitoring: '✓ مراقبة واكتشاف الحوادث',
  dataSharing: 'مشاركة البيانات',
  dataSharingText1: 'لا تبيع Ktran أو تؤجر أو تشارك بياناتك الشخصية مع أطراف ثالثة لأغراض تجارية.',
  dataSharingText2: 'يمكن مشاركة بياناتك فقط في الحالات التالية:',
  serviceProviders: 'مقدمو الخدمات',
  serviceProvidersDesc: 'استضافة الويب (Vercel)، خدمات البريد الإلكتروني المعاملاتي (Resend) المتوافقة مع اللائحة العامة لحماية البيانات',
  legalObligationsSharing: 'الالتزامات القانونية',
  legalObligationsSharingDesc: 'السلطات القضائية أو الإدارية في حالة الطلب القانوني',
  subcontractors: 'المقاولون من الباطن',
  subcontractorsDesc: 'فقط إذا كان ذلك ضرورياً لتنفيذ مشروعك (مع اتفاقية سرية تعاقدية)',
  euLocation: 'جميع مقدمي الخدمات لدينا موجودون في الاتحاد الأوروبي أو يضمنون مستوى حماية مكافئ للائحة العامة لحماية البيانات.',
  rightToComplain: 'حق تقديم شكوى',
  rightToComplainText: 'إذا كنت تعتقد أن معالجة بياناتك الشخصية تشكل انتهاكاً للائحة العامة لحماية البيانات، فلديك الحق في تقديم شكوى إلى سلطة الرقابة البلجيكية:',
  dataProtectionAuthority: 'هيئة حماية البيانات (APD)',
  belgiumAddress: 'العنوان: Rue de la Presse 35، 1000 بروكسل، بلجيكا',
  policyModifications: 'تعديلات السياسة',
  policyModificationsText: 'تحتفظ Ktran بالحق في تعديل سياسة الخصوصية هذه في أي وقت. سيتم نشر أي تعديل على هذه الصفحة مع تاريخ تحديث جديد. نشجعك على مراجعة هذه الصفحة بانتظام للبقاء على اطلاع بكيفية حماية بياناتك.',

  // Terms of Use
  termsOfUseTitle: 'شروط الاستخدام',
  termsOfUseDescription: 'الشروط العامة لاستخدام موقع ktran.be',
  acceptanceOfTerms: 'قبول الشروط',
  acceptanceText: 'من خلال الوصول إلى واستخدام موقع ktran.be (المشار إليه فيما يلي بـ "الموقع")، فإنك توافق على الالتزام بشروط الاستخدام العامة هذه. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام هذا الموقع.',
  purpose: 'الغرض',
  purposeText1: 'تهدف شروط الاستخدام العامة (CGU) هذه إلى تحديد شروط وأحكام استخدام الموقع، بالإضافة إلى حقوق والتزامات المستخدمين وKtran.',
  purposeText2: 'يتم نشر الموقع بواسطة:',
  siteAccess: 'الوصول إلى الموقع',
  siteAccessText1: 'الموقع متاح مجاناً لأي مستخدم لديه إمكانية الوصول إلى الإنترنت. جميع التكاليف التي يتحملها المستخدم للوصول إلى الخدمة (معدات الكمبيوتر، البرامج، اتصال الإنترنت، إلخ) على عاتقه.',
  siteAccessText2: 'تبذل Ktran جميع الوسائل المعقولة المتاحة لها لضمان وصول عالي الجودة إلى الموقع، ولكنها غير ملزمة بتحقيق ذلك.',
  serviceInterruptions: '⚠️ انقطاع الخدمة',
  serviceInterruptionsText: 'تحتفظ Ktran بالحق في مقاطعة أو تعليق أو تعديل الوصول إلى كل أو جزء من الموقع مؤقتاً دون إشعار مسبق، لا سيما لأسباب الصيانة أو التحديث أو لأي سبب تقني آخر، دون أن يفتح الانقطاع الحق في أي التزام أو تعويض.',
  servicesOffered: 'الخدمات المقدمة',
  servicesOfferedText1: 'يهدف الموقع إلى توفير معلومات حول خدمات التجديد التي تقدمها Ktran والسماح للمستخدمين بـ:',
  servicesOfferedList1: 'الاطلاع على خدمات التجديد المتاحة',
  servicesOfferedList2: 'اكتشاف المشاريع المنجزة',
  servicesOfferedList3: 'تقديم طلبات عروض الأسعار عبر الإنترنت',
  servicesOfferedList4: 'الاتصال بالشركة للحصول على معلومات',
  servicesOfferedNote: 'تسعى Ktran جاهدة لتوفير معلومات دقيقة قدر الإمكان. ومع ذلك، لا يمكن تحميلها المسؤولية عن الإغفالات أو عدم الدقة والنقص في التحديث، سواء كانت من فعلها أو من فعل الشركاء الخارجيين الذين يزودونها بهذه المعلومات.',
  userObligations: 'التزامات المستخدم',
  userObligationsText: 'يلتزم المستخدم باستخدام الموقع وفقاً لشروط الاستخدام العامة هذه والتشريعات السارية. يُحظر على وجه الخصوص:',
  prohibitedUses: '🚫 الاستخدامات المحظورة',
  prohibitedUsesList1: '• استخدام الموقع لأغراض غير قانونية أو احتيالية',
  prohibitedUsesList2: '• انتهاك حقوق الملكية الفكرية لـ Ktran',
  prohibitedUsesList3: '• نشر محتوى غير قانوني أو تشهيري أو مسيء',
  prohibitedUsesList4: '• محاولة الوصول غير المصرح به إلى نظام الكمبيوتر',
  prohibitedUsesList5: '• تعطيل التشغيل العادي للموقع',
  prohibitedUsesList6: '• جمع البيانات الشخصية للمستخدمين الآخرين',
  prohibitedUsesList7: '• استخدام الروبوتات أو البرامج النصية أو الوسائل الآلية الأخرى',
  userObligationsText2: 'يلتزم المستخدم بتقديم معلومات دقيقة ومحدثة عند تقديم النماذج. يمكن أن يؤدي أي إعلان كاذب إلى رفض الطلب.',
  quoteRequestsSection: 'طلبات عروض الأسعار',
  quoteRequestsText1: 'طلبات عروض الأسعار المقدمة عبر الموقع مجانية وبدون التزام. تسمح لـ Ktran بتقييم مشروعك وتقديم عرض مخصص لك.',
  requestProcess: '📋 عملية الطلب',
  requestProcessStep1: '1. ملء النموذج عبر الإنترنت بتفاصيل مشروعك',
  requestProcessStep2: '2. تقديم الطلب (مع صور اختيارية)',
  requestProcessStep3: '3. استلام وتحليل طلبك من قبل Ktran',
  requestProcessStep4: '4. الاتصال عبر البريد الإلكتروني أو الهاتف لمناقشة المشروع',
  requestProcessStep5: '5. إعداد عرض أسعار مفصل (خلال 48-72 ساعة عمل)',
  important: 'مهم',
  quoteRequestsNote: 'تقديم طلب عرض أسعار لا يشكل التزاماً تعاقدياً. عرض الأسعار المقدم من Ktran صالح لمدة 30 يوماً من تاريخ إصداره، ما لم يُذكر خلاف ذلك.',
  intellectualPropertySection: 'الملكية الفكرية',
  intellectualPropertySectionText1: 'جميع عناصر الموقع (الهيكل، النصوص، الصور، الشعارات، مقاطع الفيديو، الأصوات، قواعد البيانات، البرامج، إلخ) هي ملكية حصرية لـ Ktran أو تخضع لترخيص استخدام.',
  intellectualPropertySectionText2: 'يُحظر أي استنساخ أو تمثيل أو تعديل أو نشر أو تكييف لكل أو جزء من عناصر الموقع، بغض النظر عن الوسيلة أو الإجراء المستخدم، ما لم يتم الحصول على إذن كتابي مسبق من Ktran.',
  authorizedUse: '✅ الاستخدام المصرح به',
  authorizedUseText: 'يُسمح لك بالاطلاع على الموقع وطباعة الصفحات لاستخدامك الشخصي والخاص، بشرط عدم إزالة إشعارات الملكية الفكرية.',
  intellectualPropertySectionText3: 'سيُعتبر أي استغلال غير مصرح به للموقع أو أي من العناصر التي يحتوي عليها بمثابة تزوير وسيتم ملاحقته وفقاً لأحكام المواد L.335-2 وما يليها من قانون الملكية الفكرية.',
  responsibilitySection: 'حدود المسؤولية',
  responsibilitySectionText1: 'لا يمكن تحميل Ktran المسؤولية عن الأضرار المباشرة وغير المباشرة التي تلحق بمعدات المستخدم، عند الوصول إلى الموقع، والناتجة إما عن استخدام معدات لا تستوفي المواصفات المشار إليها، أو ظهور خطأ أو عدم توافق.',
  responsibilitySectionText2: 'تخلي Ktran مسؤوليتها فيما يتعلق بـ:',
  responsibilityList1: 'انقطاع أو خلل في الموقع',
  responsibilityList2: 'الأخطاء أو الإغفالات في محتوى الموقع',
  responsibilityList3: 'الأضرار الناتجة عن تدخل احتيالي من طرف ثالث',
  responsibilityList4: 'فيروسات الكمبيوتر',
  responsibilityList5: 'محتوى مواقع الطرف الثالث التي يشير إليها الموقع',
  responsibilityList6: 'الاستخدام الاحتيالي أو المسيء للموقع من قبل المستخدم',
  forceMajeure: 'القوة القاهرة',
  forceMajeureText: 'لن تكون Ktran مسؤولة في حالة القوة القاهرة أو الأحداث الخارجة عن إرادتها (الكوارث الطبيعية، الإضرابات، انقطاع الشبكة، إلخ).',
  hyperlinksSection: 'الروابط التشعبية',
  hyperlinksSectionText1: 'قد يحتوي الموقع على روابط تشعبية لمواقع إنترنت أخرى. لا تمارس Ktran أي سيطرة على هذه المواقع وتخلي مسؤوليتها عن محتواها أو توفرها أو سياسة الخصوصية الخاصة بها.',
  hyperlinksSectionText2: 'يتطلب إنشاء روابط تشعبية إلى الموقع الحصول على إذن مسبق وكتابي من Ktran. يمكن إلغاء هذا الإذن في أي وقت.',
  dataProtectionSection: 'حماية البيانات الشخصية',
  dataProtectionSectionText1: 'يتم معالجة البيانات الشخصية المجمعة عبر الموقع وفقاً لـ',
  dataProtectionSectionText2: 'واللائحة العامة لحماية البيانات.',
  dataProtectionSectionText3: 'لديك حق الوصول والتصحيح والمحو والتقييد والنقل والاعتراض فيما يتعلق ببياناتك الشخصية. لممارسة هذه الحقوق، اتصل بنا على',
  cookiesSection: 'ملفات تعريف الارتباط',
  cookiesSectionText: 'يستخدم الموقع ملفات تعريف الارتباط لتحسين تجربة المستخدم وتحليل حركة المرور. لمزيد من المعلومات حول استخدامنا لملفات تعريف الارتباط وكيفية إدارتها، راجع',
  termsModification: 'تعديل الشروط',
  termsModificationText1: 'تحتفظ Ktran بالحق في تعديل شروط الاستخدام العامة هذه في أي وقت. تدخل التعديلات حيز التنفيذ فور نشرها على الموقع. يُنصح المستخدمون بمراجعة هذه الصفحة بانتظام للاطلاع على أي تعديلات.',
  termsModificationNote: 'يشكل استخدام الموقع بعد نشر التعديلات قبولاً لهذه التعديلات.',
  applicableLawSection: 'القانون المطبق والاختصاص القضائي',
  applicableLawSectionText1: 'تخضع شروط الاستخدام العامة هذه للقانون البلجيكي والأوروبي.',
  applicableLawSectionText2: 'في حالة نشوب نزاع وفي حالة عدم التوصل إلى اتفاق ودي، سيتم عرض النزاع على المحاكم المختصة في بروكسل، بلجيكا.',
  amicableSettlement: '🤝 التسوية الودية',
  amicableSettlementText: 'قبل أي إجراء قانوني، تلتزم الأطراف بالبحث عن حل ودي. في حالة الفشل، يمكنك أيضاً اللجوء إلى الوساطة أو طريقة بديلة أخرى لحل النزاعات.',
  contactUsSection: 'اتصل بنا',
  contactUsSectionText: 'لأي أسئلة تتعلق بشروط الاستخدام هذه:',

  // Data Protection
  dataProtectionTitle: 'حماية البيانات',
  dataProtectionDescription: 'الامتثال للائحة العامة لحماية البيانات وتدابير الأمان لبياناتك الشخصية',
  gdprCommitment: 'التزامنا باللائحة العامة لحماية البيانات',
  gdprCommitmentText1: 'تلتزم Ktran (رقم الضريبة: BE0729535515) التزاماً كاملاً بحماية بياناتك الشخصية واحترام اللائحة العامة لحماية البيانات (GDPR - EU 2016/679) والتشريعات البلجيكية المتعلقة بحماية الخصوصية.',
  gdprCommitmentText2: 'توضح هذه الصفحة التدابير التقنية والتنظيمية التي نطبقها لضمان أمن وسرية بياناتك.',
  gdprPrinciples: 'المبادئ الأساسية للائحة العامة لحماية البيانات',
  gdprPrinciplesText: 'نحترم المبادئ الأساسية الستة للائحة العامة لحماية البيانات في معالجة بياناتك:',
  lawfulnessTransparency: '1. المشروعية والشفافية',
  lawfulnessTransparencyDesc: 'معالجة قانونية ونزيهة وشفافة. يتم إعلامك باستخدام بياناتك.',
  purposeLimitation: '2. تحديد الأغراض',
  purposeLimitationDesc: 'الجمع لأغراض محددة وصريحة ومشروعة فقط.',
  dataMinimization: '3. تقليل البيانات',
  dataMinimizationDesc: 'الجمع محدود بالبيانات الضرورية بشكل صارم لخدماتنا.',
  accuracy: '4. الدقة',
  accuracyDesc: 'بيانات دقيقة ومحدثة. إمكانية التصحيح في أي وقت.',
  storageLimitation: '5. تحديد الاحتفاظ',
  storageLimitationDesc: 'الاحتفاظ محدود في الوقت وفقاً للأغراض والالتزامات القانونية.',
  integrityConfidentiality: '6. السلامة والسرية',
  integrityConfidentialityDesc: 'أمان مناسب ضد المعالجة غير المصرح بها أو غير القانونية.',
  technicalSecurityMeasures: 'تدابير الأمان التقنية',
  technicalSecurityMeasuresText: 'نطبق تدابير أمان تقنية متقدمة لحماية بياناتك:',
  dataEncryption: 'تشفير البيانات',
  sslTls: 'SSL/TLS (HTTPS)',
  sslTlsDesc: 'جميع الاتصالات بين متصفحك وخوادمنا مشفرة',
  encryptionAtRest: 'التشفير في حالة السكون',
  encryptionAtRestDesc: 'البيانات الحساسة مشفرة في قاعدة البيانات',
  secureProtocols: 'البروتوكولات الآمنة',
  secureProtocolsDesc: 'استخدام TLS 1.3 للاتصالات',
  accessControl: 'التحكم في الوصول',
  strongAuthentication: 'المصادقة القوية',
  strongAuthenticationDesc: 'الوصول الإداري محمي بكلمة مرور آمنة',
  leastPrivilege: 'مبدأ الامتياز الأدنى',
  leastPrivilegeDesc: 'الوصول محدود للأشخاص المصرح لهم فقط',
  secureSessions: 'الجلسات الآمنة',
  secureSessionsDesc: 'انتهاء صلاحية تلقائي للجلسات غير النشطة',
  logging: 'التسجيل',
  loggingDesc: 'تتبع الوصول إلى البيانات الحساسة',
  secureInfrastructure: 'البنية التحتية الآمنة',
  certifiedHosting: 'استضافة معتمدة',
  certifiedHostingDesc: 'خوادم مستضافة في الاتحاد الأوروبي (الامتثال للائحة العامة لحماية البيانات)',
  firewall: 'جدار الحماية',
  firewallDesc: 'الحماية من التطفل والهجمات',
  automaticBackups: 'النسخ الاحتياطية التلقائية',
  automaticBackupsDesc: 'نسخ احتياطية يومية مشفرة وآمنة',
  monitoring247: 'المراقبة 24/7',
  monitoring247Desc: 'مراقبة مستمرة للأمان',
  threatProtection: 'الحماية من التهديدات',
  antiMalware: 'الحماية من البرامج الضارة',
  antiMalwareDesc: 'اكتشاف وحظر البرامج الضارة',
  ddosProtection: 'الحماية من DDoS',
  ddosProtectionDesc: 'الدفاع ضد هجمات رفض الخدمة',
  inputValidation: 'التحقق من صحة المدخلات',
  inputValidationDesc: 'الحماية من حقن SQL و XSS',
  regularUpdates: 'التحديثات المنتظمة',
  regularUpdatesDesc: 'تطبيق تصحيحات الأمان بسرعة',
  organizationalMeasures: 'التدابير التنظيمية',
  organizationalMeasuresText: 'بالإضافة إلى التدابير التقنية، قمنا بتطبيق إجراءات تنظيمية صارمة:',
  internalPrivacyPolicy: '📋 سياسة السرية الداخلية',
  internalPrivacyPolicyDesc: 'جميع المتعاونين الذين لديهم إمكانية الوصول إلى البيانات مدربون ومطلعون على حماية البيانات الشخصية وملزمون بالتزام السرية.',
  impactAnalysis: '🔍 تحليل الأثر (PIA)',
  impactAnalysisDesc: 'نجري تحليلات تأثير على حماية البيانات للمعالجات التي تمثل مخاطر عالية.',
  completeDocumentation: '📝 التوثيق الكامل',
  completeDocumentationDesc: 'سجل أنشطة المعالجة محدث وفقاً للمادة 30 من اللائحة العامة لحماية البيانات.',
  incidentManagement: '🚨 إجراء إدارة الحوادث',
  incidentManagementDesc: 'خطة الاستجابة لانتهاكات البيانات مع الإخطار لسلطة الرقابة في غضون 72 ساعة إذا لزم الأمر.',
  dataTransfers: 'نقل البيانات',
  dataTransfersText1: 'يتم استضافة ومعالجة بياناتك الشخصية داخل الاتحاد الأوروبي، مما يضمن أعلى مستوى من الحماية.',
  euHosting: '🇪🇺 الاستضافة في الاتحاد الأوروبي',
  euHostingList1: '✓ خوادم موجودة في الاتحاد الأوروبي',
  euHostingList2: '✓ الامتثال الكامل للائحة العامة لحماية البيانات',
  euHostingList3: '✓ لا يوجد نقل إلى دول ثالثة دون ضمانات مناسبة',
  euHostingList4: '✓ مقاولون من الباطن معتمدون ومتوافقون مع اللائحة العامة لحماية البيانات',
  transferNote: 'إذا كان نقل البيانات خارج الاتحاد الأوروبي ضرورياً في المستقبل، فسنضمن أنه محاط بضمانات مناسبة (البنود التعاقدية النموذجية للمفوضية الأوروبية، قرار الكفاية، إلخ) وسنبلغك بذلك.',
  subcontractorsPartners: 'المقاولون من الباطن والشركاء',
  subcontractorsPartnersText: 'نعمل فقط مع المقاولين من الباطن الذين يقدمون ضمانات كافية فيما يتعلق بحماية البيانات:',
  subcontractor: 'المقاول من الباطن',
  service: 'الخدمة',
  location: 'الموقع',
  compliance: 'الامتثال',
  webHosting: 'استضافة الويب',
  database: 'قاعدة البيانات',
  eu: 'الاتحاد الأوروبي',
  subcontractingContracts: 'عقود المقاولة من الباطن',
  subcontractingContractsText: 'جميع المقاولين من الباطن لدينا ملزمون بعقود متوافقة مع المادة 28 من اللائحة العامة لحماية البيانات، مما يضمن أمن وسرية بياناتك.',
  exercisingYourRights: 'ممارسة حقوقك',
  exercisingYourRightsText: 'لديك حقوق على بياناتك الشخصية. إليك كيفية ممارستها:',
  howToMakeRequest: '📧 كيفية تقديم طلب؟',
  byEmail: '1. عبر البريد الإلكتروني',
  byPhone: '2. عبر الهاتف',
  byMail: '3. عبر البريد',
  informationToProvide: 'المعلومات المطلوب تقديمها',
  yourNameSurname: '• اسمك ولقبك',
  yourEmail: '• عنوان بريدك الإلكتروني',
  requestNature: '• طبيعة طلبك (الوصول، التصحيح، المحو، إلخ)',
  idCopy: '• نسخة من بطاقة هويتك (للتحقق)',
  responseDeadline: '⏱️ موعد الرد',
  responseDeadlineText: 'نلتزم بالرد على طلبك في غضون شهر واحد كحد أقصى من تاريخ استلامه. يمكن تمديد هذا الموعد لمدة شهرين في حالة الطلب المعقد.',
  freeOfCharge: '💰 مجاناً',
  freeOfChargeText: 'ممارسة حقوقك مجانية. ومع ذلك، في حالة الطلبات الواضحة بلا أساس أو المفرطة، قد نطلب دفع رسوم معقولة.',
  dataBreachManagement: 'إدارة انتهاكات البيانات',
  dataBreachManagementText: 'في حالة انتهاك البيانات الشخصية الذي قد يشكل خطراً كبيراً على حقوقك وحرياتك، نلتزم بـ:',
  rapidNotification: 'إخطار سريع',
  rapidNotificationDesc: 'إخطار هيئة حماية البيانات (APD) في غضون 72 ساعة',
  affectedPersonsNotification: 'إعلام الأشخاص المعنيين',
  affectedPersonsNotificationDesc: 'سيتم إعلامك دون تأخير إذا كان الانتهاك يمثل خطراً كبيراً عليك',
  correctiveMeasures: 'التدابير التصحيحية',
  correctiveMeasuresDesc: 'تطبيق فوري للتدابير للحد من العواقب',
  documentation: 'التوثيق',
  documentationDesc: 'الاحتفاظ بسجل للانتهاكات وفقاً للمادة 33 من اللائحة العامة لحماية البيانات',
  supervisoryAuthority: 'سلطة الرقابة',
  supervisoryAuthorityText: 'إذا كنت تعتقد أن حقوقك لا تُحترم، يمكنك تقديم شكوى إلى سلطة الرقابة البلجيكية:',
  apdAddress: '📍 العنوان',
  apdAddressText: 'Rue de la Presse 35، 1000 بروكسل، بلجيكا',
  apdContact: '📞 الاتصال',
  apdWebsite: '🌐 الموقع الإلكتروني',
  contactUsDataProtection: 'اتصل بنا',
  contactUsDataProtectionText: 'لأي أسئلة تتعلق بحماية بياناتك الشخصية:',
  dataControllerResponsible: 'المسؤول عن المعالجة',

  // Cookie Policy - already exists above
  cookiePolicyDescription: 'معلومات حول استخدام ملفات تعريف الارتباط على موقعنا',
  whatIsCookie: 'ما هو ملف تعريف الارتباط؟',
  cookieDefinition: 'ملف تعريف الارتباط (Cookie) هو ملف نصي صغير يتم تخزينه على جهازك (كمبيوتر، جهاز لوحي، هاتف ذكي) عند زيارة موقع ويب. تسمح ملفات تعريف الارتباط للموقع بتذكر إجراءاتك وتفضيلاتك لفترة معينة، حتى لا تضطر إلى إعادة إدخالها في كل زيارة أو عند التنقل بين الصفحات.',
  
  cookieTypesTitle: 'أنواع ملفات تعريف الارتباط المستخدمة',
  
  // Essential Cookies
  essentialCookiesTitle: '1. ملفات تعريف الارتباط الضرورية للغاية',
  essentialCookiesDesc: 'هذه الملفات ضرورية لتشغيل الموقع ولا يمكن تعطيلها. يتم إنشاؤها عادةً استجابةً للإجراءات التي تقوم بها (تسجيل الدخول، ملء النماذج).',
  examples: 'أمثلة',
  sessionCookies: 'ملفات تعريف ارتباط الجلسة (مصادقة المسؤول)',
  securityCookies: 'ملفات تعريف ارتباط الأمان (حماية CSRF)',
  languageCookies: 'ملفات تعريف ارتباط تفضيلات اللغة',
  duration: 'المدة',
  sessionOrOneYear: 'الجلسة أو حتى سنة واحدة',
  consentRequired: 'الموافقة مطلوبة',
  no: 'لا',
  necessaryForOperation: 'ضرورية للتشغيل',
  yes: 'نعم',
  
  // Functional Cookies
  functionalCookiesTitle: '2. ملفات تعريف الارتباط الوظيفية',
  functionalCookiesDesc: 'تسمح هذه الملفات بتحسين وظائف الموقع وتخصيصه (تذكر تفضيلاتك).',
  formPreferences: 'تذكر اختيارات النموذج',
  displayPreferences: 'تفضيلات العرض',
  navigationSettings: 'إعدادات التنقل',
  upTo13Months: 'حتى 13 شهرًا',
  
  // Analytics Cookies
  analyticsCookiesTitle: '3. ملفات تعريف الارتباط التحليلية',
  analyticsCookiesDesc: 'تسمح لنا هذه الملفات بفهم كيفية استخدام الزوار لموقعنا، من أجل تحسين تجربة المستخدم.',
  collectedInfo: 'المعلومات المجمعة',
  trafficSource: 'مصدر الزيارات',
  navigationBehavior: 'سلوك التنقل',
  anonymizedDemographics: 'البيانات الديموغرافية المجهولة',
  
  // Marketing Cookies
  marketingCookiesTitle: '4. ملفات تعريف الارتباط التسويقية (غير مستخدمة حاليًا)',
  marketingCookiesDesc: 'لا تستخدم Ktran حاليًا أي ملفات تعريف ارتباط تسويقية أو إعلانية مستهدفة. إذا تغير ذلك، سنبلغك ونطلب موافقتك الصريحة.',
  
  // Third Party Cookies
  thirdPartyCookies: 'ملفات تعريف الارتباط من طرف ثالث',
  thirdPartyCookiesDesc: 'قد يستخدم موقعنا خدمات طرف ثالث تضع ملفات تعريف الارتباط الخاصة بها:',
  googleMapsDesc: 'يُستخدم لعرض الخرائط التفاعلية',
  hosting: 'الاستضافة',
  note: 'ملاحظة',
  thirdPartyNote: 'نحن لا نتحكم في ملفات تعريف الارتباط التي تضعها خدمات الطرف الثالث هذه. نوصيك بالاطلاع على سياسات الخصوصية الخاصة بها.',
  
  // Cookie Management
  manageCookiesTitle: 'كيفية إدارة ملفات تعريف الارتباط الخاصة بك؟',
  viaBrowser: '1. عبر متصفحك',
  browserConfigDesc: 'يمكنك تكوين متصفحك لقبول أو رفض ملفات تعريف الارتباط. إليك روابط التعليمات للمتصفحات الأكثر شيوعًا:',
  
  refusalConsequences: 'عواقب رفض ملفات تعريف الارتباط',
  refusalConsequencesDesc: 'إذا اخترت تعطيل ملفات تعريف الارتباط، فقد لا تعمل بعض وظائف الموقع بشكل صحيح:',
  cannotStayLoggedIn: 'عدم القدرة على البقاء متصلاً (منطقة المسؤول)',
  lossOfPreferences: 'فقدان تفضيلات التنقل الخاصة بك',
  formsNotSubmitting: 'النماذج التي لا يتم إرسالها بشكل صحيح',
  degradedExperience: 'تجربة مستخدم متدهورة',
  
  deletingCookies: '2. حذف ملفات تعريف الارتباط الموجودة',
  deletingCookiesDesc: 'يمكنك حذف ملفات تعريف الارتباط المخزنة بالفعل على جهازك في أي وقت عبر إعدادات متصفحك. سيؤدي هذا الإجراء إلى حذف جميع ملفات تعريف الارتباط، بما في ذلك تلك الضرورية للتشغيل السليم للموقع.',
  
  // Retention Period
  cookieType: 'نوع ملف تعريف الارتباط',
  maxDuration: 'المدة القصوى',
  sessionCookiesType: 'ملفات تعريف ارتباط الجلسة',
  untilBrowserClose: 'حتى إغلاق المتصفح',
  essentialCookiesType: 'ملفات تعريف الارتباط الضرورية للغاية',
  twelveMonths: '12 شهرًا',
  functionalCookiesType: 'ملفات تعريف الارتباط الوظيفية',
  thirteenMonths: '13 شهرًا',
  analyticsCookiesType: 'ملفات تعريف الارتباط التحليلية',
  gdprComplianceNote: 'وفقًا لتوجيه ePrivacy واللائحة العامة لحماية البيانات (GDPR)، لا يمكن أن تتجاوز مدة الاحتفاظ بملفات تعريف الارتباط 13 شهرًا.',
  
  // Legal Basis
  legalBasisTitle: 'الأساس القانوني والامتثال',
  legalBasisDesc: 'استخدامنا لملفات تعريف الارتباط يتوافق مع اللوائح التالية:',
  gdprFull: 'اللائحة الأوروبية 2016/679 - حماية البيانات الشخصية',
  ePrivacyDirective: 'توجيه ePrivacy',
  belgianLaw: 'القانون البلجيكي المؤرخ 13 يونيو 2005 المتعلق بالاتصالات الإلكترونية',
  consentDesc: 'وفقًا للتشريعات، نطلب موافقتك قبل وضع ملفات تعريف ارتباط غير ضرورية. يمكنك سحب موافقتك في أي وقت.',
  
  // Contact
  questionsAboutCookies: 'أسئلة حول ملفات تعريف الارتباط؟',
  contactUsForQuestions: 'لأي أسئلة تتعلق باستخدامنا لملفات تعريف الارتباط، اتصل بنا:',
};